import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchActivePlan,
    selectActivePlan,
} from '../features/workout/workout-plan/workout-plan.slice';

const useActiveWorkoutPlan = (memberId?: number) => {
    const dispatch = useAppDispatch();
    const workoutPlan = useAppSelector(selectActivePlan);

    useEffect(() => {
        if (!memberId || memberId <= 0) return;

        const fetchPlan = async () => {
            await dispatch(fetchActivePlan(memberId));
        };

        fetchPlan();
    }, [memberId, dispatch]);

    return workoutPlan;
};

export default useActiveWorkoutPlan;
